import Icons from "./Icons.component";

export default Icons;
